<template>
  <div>
    <img v-show="charindex == 1" class="char" src="../assets/0.開始遊戲/0_1.選擇腳色/腳色介面_01-選擇1.png" />
    <img v-show="charindex == 2" class="char" src="../assets/0.開始遊戲/0_1.選擇腳色/腳色介面_01-選擇2.png" />
    <img v-show="charindex == 3" class="char" src="../assets/0.開始遊戲/0_1.選擇腳色/腳色介面_01-選擇3.png" />
    <img class="leftarrow" src="../assets/0.開始遊戲/0_1.選擇腳色/腳色介面_01-左鍵.png" @click="OnPrev" />
    <img class="rightarrow" src="../assets/0.開始遊戲/0_1.選擇腳色/腳色介面_01-右鍵.png" @click="OnNext" />
    <img
      class="select"
      src="../assets/0.開始遊戲/0_1.選擇腳色/腳色介面_01-選擇鍵.png"
      @click="OnCarSelected(charindex)"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      charindex: 1
    };
  },
  props: {
    OnCarSelected: {
      type: Function
    }
  },
  methods: {
    OnNext() {
      if (this.charindex + 1 > 3) {
        this.charindex = 1;
      } else {
        this.charindex++;
      }
    },
    OnPrev() {
      if (this.charindex - 1 < 1) {
        this.charindex = 3;
      } else {
        this.charindex--;
      }
    }
  }
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.char {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
}
.leftarrow {
  position: absolute;
  top: 119vw;
  left: 9vw;
  width: 13vw;
}
.rightarrow {
  position: absolute;
  top: 119vw;
  right: 9vw;
  width: 13vw;
}
.select {
  position: absolute;
  top: 141vw;
  right: 30vw;
  width: 41vw;
}
</style>
